import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const Leftbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const isLoggedIn = localStorage.getItem("accessToken") ? true : false;

  const location = useLocation();
  const isChatRoute = location.pathname.startsWith("/chat");
  const isPersonalChatRoute = location.pathname.startsWith("/personal-chat");
  const isContactsRoute = location.pathname.startsWith("/contacts");
  const isAlertsRoute = location.pathname.startsWith("/alerts");
  const isInboxRoute = location.pathname.startsWith("/inbox");
  const isCoursesRoute = location.pathname.startsWith("/courses");
  const isProfileRoute = location.pathname.startsWith("/profile");
  const isNoPaddingRoute = isChatRoute || isPersonalChatRoute || isContactsRoute || isAlertsRoute || isInboxRoute || isCoursesRoute || isProfileRoute;
  const isChatView = (isChatRoute || isPersonalChatRoute) && location.pathname.split('/').filter(Boolean).length > 1;

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  if (!isLoggedIn) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden font-sans">
      {/* Sidebar Component */}
      <div className={`${isChatView ? "hidden lg:block" : "block"}`}>
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={closeSidebar} 
          isCollapsed={sidebarCollapsed} 
          setIsCollapsed={setSidebarCollapsed} 
        />
      </div>

      {/* Main Content Area */}
      <div className={`flex flex-col flex-1 min-w-0 h-full overflow-hidden transition-all duration-300 relative ${isChatView ? "m-0" : "sm:mt-0"}`}>
        {/* Navbar Component */}
        <div className={`${isChatView ? "hidden lg:block" : "block"}`}>
          <Navbar onToggleSidebar={toggleSidebar} />
        </div>

        {/* Scrollable Content */}
        <main className={`flex-1 overflow-hidden sm:px-6 pb-0 sm:pb-6 scroll-smooth flex flex-col min-h-0 ${isChatView ? "px-0" : "px-4 pb-4"}`}>
          <div className={`flex-1 transition-colors duration-300 overflow-hidden rounded-xl shadow-md bg-white text-gray-800 ${isNoPaddingRoute ? 'p-0 h-full' : ''} ${isChatView ? "rounded-none shadow-none sm:rounded-xl sm:shadow-md h-full" : ""}`}>
            <div className={`h-full flex flex-col ${isNoPaddingRoute ? 'overflow-hidden' : 'overflow-y-auto'}`}>
              <div className={`${isNoPaddingRoute ? 'h-full' : 'p-6 min-h-full'}`}>
                <Outlet />
              </div>
            </div>
          </div>
        </main>

        {/* Footer Component */}
        {!isNoPaddingRoute && (
          <footer className="px-4 sm:px-6 py-4 border-t border-gray-100 text-gray-500 flex-shrink-0">
            <div className="flex flex-col sm:flex-row justify-between items-center text-[10px] sm:text-xs">
              <span className="text-center sm:text-left">
                &copy; {new Date().getFullYear()} Developed and Maintained by{" "}
                <span className="font-semibold text-indigo-500 text-nowrap">It's all About the Options</span>
              </span>
            </div>
          </footer>
        )}
      </div>
    </div>
  );
};

export default Leftbar;
